<strong><span [ngClass]="class">{{value}}</span></strong>